// extracted by mini-css-extract-plugin
export default {"singleHazardInfo":"results_singleHazardInfo__BXUQV","resultsSingle":"results_resultsSingle__DbcES","resultsMultiple":"results_resultsMultiple__88+Ml"};